import { useAuth } from '../../auth/useAuth';
import { graphql } from '../../gql';
import { useApiQuery } from '../../query/hooks';

export enum AclAction {
	MANAGE_MEMBERS,
}

type Result = Readonly<{
	isAuthenticated: boolean;
	hasOrganizationAccess?: boolean;
	isActionAllowed: boolean;
	isTrialExpired: boolean;
	isTrial: boolean;
}>;

const getOrganizationMetaLicense = graphql(`
	query currentOrganization_license {
		getOrganizationMeta(by: { id: singleton }) {
			license
			trialEndDate
			status
		}
	}
`);

const useAuthGuard = (action?: AclAction): Result => {
	const auth = useAuth();
	const expiredPageEnabled = false; // @todo

	const isAuthenticated = !auth.isLoading && auth.isSignedIn;

	const hasOrganizationAccess = isAuthenticated ? Boolean(auth.me.person?.roles && auth.me.person.roles.length > 0) : undefined;

	const { data } = useApiQuery(getOrganizationMetaLicense, { enabled: isAuthenticated && expiredPageEnabled });

	const isTrialExpired = data?.getOrganizationMeta?.license === 'expired';

	const isTrial = data?.getOrganizationMeta?.license === 'trial';

	const aclActions: AclAction[] = [];
	if (isAuthenticated && auth.me.person?.roles.includes('owner')) {
		aclActions.push(AclAction.MANAGE_MEMBERS);
	}
	const isActionAllowed = action != null ? aclActions.includes(action) : true;

	return { isAuthenticated, hasOrganizationAccess, isActionAllowed, isTrialExpired, isTrial };
};

export { useAuthGuard };
